module.exports = __webpack_public_path__ + "img/shakeri.b749a5c2.png";